// Vendors
import React from 'react';
// Components
import { LandingOptionsComponent } from 'components/landing-options/landing-options.component';
// Configurations
import { getFeaturesProofIncomeConfiguration } from './configurations/proof-income-landing.configuration';
// Constants
import { PROOF_INCOME_LANDING_MODAL_CONFIGURATION } from './constants/proof-income-landing.constants';
// Enumerations
import { ProofIncomeMethodsEnumeration } from '../../enumerations/proof-income-methods.enumeration';
// Hooks
import { useProofIncomeLandingHook } from './hooks/proof-income-landing.hook';

const ProofIncomeLandingView = (): React.JSX.Element => {
  const {
    handleManageProofIncomeMethodContinueClick: onContinue,
    handleOnSelectMethod: onSelectMethod,
    handleTrackContinue: onContinueToModal,
    handleTrackCloseModal: onCloseModal,
    handleTrackOpenModal: onOpenModal,
    selectedMethod,
    ...restProps
  } = useProofIncomeLandingHook();

  return (
    <LandingOptionsComponent<ProofIncomeMethodsEnumeration>
      {...{ onSelectMethod, selectedMethod }}
      modalConfiguration={{
        ...PROOF_INCOME_LANDING_MODAL_CONFIGURATION,
        onContinue,
        onContinueToModal,
        onOpenModal,
        onCloseModal,
      }}
      options={getFeaturesProofIncomeConfiguration(restProps)}
    />
  );
};

export { ProofIncomeLandingView };
